<div [class]="{ load: !fileContent }">
    <h2 mat-dialog-title class="mat-title">
        <p>
            {{ 'APP.notices' | translate }}
        </p>
        <div (click)="onCancelClick()">
            <span class="close-dialog">&#10006;</span>
        </div>
    </h2>
    <mat-dialog-content>
        <ng-container *ngIf="fileContent; else loading">
            <p [innerText]="fileContent"></p>
        </ng-container>
        <ng-template #loading>
            <div class="spinner">
                <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
        </ng-template>
    </mat-dialog-content>
</div>
